/**
 * Operating system types
 */
export type OperatingSystem = 'Windows' | 'Mac' | 'Chrome' | 'Unsupported' | 'Not known';

/**
 * Detects the operating system from the window object
 * 
 * @param {Window} windowObj - The window object to detect OS from
 * @returns {OperatingSystem} The detected operating system
 */
export function getOperatingSystem(windowObj: Window): OperatingSystem {
  let operatingSystem: OperatingSystem = 'Not known';
  
  if (windowObj.navigator.appVersion.indexOf('Win') !== -1) {
    operatingSystem = 'Windows';
  } else if (windowObj.navigator.appVersion.indexOf('Mac') !== -1) {
    operatingSystem = 'Mac';
  } else if (windowObj.navigator.appVersion.indexOf('Chrome') !== -1) {
    operatingSystem = 'Chrome';
  } else {
    operatingSystem = 'Unsupported';
  }

  return operatingSystem;
}
